import { InvalidOperationException } from "../../../../Global/Base/Exceptions";
import { OWObject } from "../../../../OW.Remoting/Remoting/DataTypes/OWObject";
import { IAttributeControl, IHTMLElementWithControl } from "../../UI/Controls/ControlInterfaces";
import { IContentBuilder } from "../../UI/DataBuilders/IContentBuilder";
import { LocalizedStringBuilder } from "../../UI/DataBuilders/LocalizedStringBuilder";
import { SectionHandler } from "./SectionHandler";
/**
 * @internal
 */
export class PasswordSectionHandler extends SectionHandler {
    private readonly _passwordNewControl1: IAttributeControl;
    private readonly _passwordNewControl2: IAttributeControl;

    constructor(rootElement: Element, createObjectFunction: () => Promise<OWObject>, saveFunction: (obj: OWObject) => Promise<void>,
        showErrorFunction: (content: IContentBuilder) => Promise<void>, _passwordElemOld: string, passwordElemNew1: string, passwordElemNew2: string,
        roles?: readonly string[]) {
        super(rootElement, createObjectFunction, saveFunction, showErrorFunction, roles);

        this._passwordNewControl1 = PasswordSectionHandler._findPasswordControl(rootElement, passwordElemNew1);
        this._passwordNewControl2 = PasswordSectionHandler._findPasswordControl(rootElement, passwordElemNew2);
    }

    private static _findPasswordControl(rootElement: Element, elementId: string): IAttributeControl {
        const controlElement = rootElement.querySelector(`#${elementId}`) as IHTMLElementWithControl; //`
        if (!(controlElement.tscControl instanceof IAttributeControl))
            throw new InvalidOperationException(`Control '${controlElement.getAttribute("data-tsccontrol")}' id ${controlElement.id} is not IAttributeControl`); //`
        return controlElement.tscControl;
    }

    protected override _checkRequirements(): boolean {
        if (!super._checkRequirements())
            return false;

        if (this._passwordNewControl1.controlValue !== this._passwordNewControl2.controlValue) {
            this._showErrorFunction(new LocalizedStringBuilder("GUI-599202")); // "Nové heslo a potvrzení nejsou shodné."
            return false;
        }

        return true;
    }
}
